import * as t from "io-ts";
import { PropertiesDataV } from "./tree";
import { MediaV } from "@/types/media";

export const ElementPresetV = t.type({
  availableForType: t.string,
  label: t.string,
  screenshotUrl: MediaV,
  designPropertiesData: PropertiesDataV
});

export type ElementPreset = t.TypeOf<typeof ElementPresetV>;

export const ElementPresetsV = t.array(ElementPresetV);
